import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { utility } from '../common/utility';
import { User } from '../models/user';


@Injectable({
  providedIn: 'root'
})

export class UserService {

    baseUrl: string;
    constructor(private http: HttpClient) {
    }

    public CanEditUser(editorid, usertoEdit): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/CanEditUser?editorUserId=" + editorid + "&userToEdit=" + usertoEdit);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('CanEditUser', [])));
    }
    public GetUserById(id): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/GetUserById?Id=" + id);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetUserById', [])));
    }
    public GetUserByEmail(email): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/GetUserByEmail?Email=" + email);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetUserByEmail', [])));
    }
    public GetVCardById(id): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/GetVCardById?Id=" + id);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetVCardById', [])));
    }
    public UpdateUserFavorite(user: any): any {
        this.baseUrl = environment.apiBase.concat("User/UpdateUserFavorite");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, user, { headers: headers }).
            pipe(catchError(utility.handleError<any>('UpdateUserFavorite', [])));
    }

    public addUser(user: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');      
        return this.http.post(this.baseUrl, user, { headers: headers }).
            pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }),);
    }

    public resetPassword(passwordViewModel: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/ResetPassword");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, passwordViewModel, { headers: headers }).
            pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }));
    }

    public requestNewToken(passwordViewModel: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/RequestNewToken");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, passwordViewModel, { headers: headers }).
            pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }));
    }

    public validateUser(user: User) {
        this.baseUrl = environment.apiBase.concat("authtoken");
        var userData = "username=" + user.username + "&password=" + user.password + "&grant_type=password";
        var headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'No-Auth': 'True' });

        return this.http.post(this.baseUrl, userData, { headers: headers })
            .pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }));
    }

    public updateUser(user: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/UpdateUser");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');

        return this.http.post(this.baseUrl, user, { headers: headers })
             .pipe(catchError(err => {
                 return utility.handleErrorNew(err);
             }));
    }

    public updateSpecialtyList(SpecialtyList: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/UpdateSpecialtyList");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');

        return this.http.post(this.baseUrl, SpecialtyList, { headers: headers })
            .pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }));
    }

    public PrintProfilePDF(userId){
        this.baseUrl = environment.apiBase.concat("Reports/getBrokerProfileReport?UserId=" + userId);       
        document.location.href = this.baseUrl;
    }

    public SearchUsers(name, includeinactive = false): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/SearchUsers?Name=" + name + "&IncludeInactive=" + includeinactive);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('SearchUsers', [])));
    }

    public SearchUsersLazy(first, numberOfRow, name, includeinactive = false): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/SearchUsersLazy?First=" + first + "&NumberOfRow=" + numberOfRow + "&Name=" + name + "&IncludeInactive=" + includeinactive);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('SearchUsers', [])));
    }
    public SearchUsersAdvanceLazy(parms): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/SearchUsersAdvanceLazy");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, parms, { headers: headers })
            .pipe(catchError(utility.handleError<any[]>('SearchUsersAdvanceLazy', [])));
    }

    public GetManagerByUserID(UserId): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/GetManagerByUserID?UserId=" + UserId);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetManagerByUserID', [])));
    }

    public SearchUsersByPropertyLocation(deal): Observable<any> {
        this.baseUrl = environment.apiBase.concat("User/SearchUsersByPropertyLocation/");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');

        return this.http.get<any[]>(this.baseUrl, { headers: headers, params: deal }).pipe(catchError(utility.handleError<any[]>('SearchUsersByPropertyLocation', [])));
    }
     
}
